// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Parse from 'parse'
import App from '@/App'
import router from '@/router'
import VueStatic from 'vue-static'
import VueToasted from 'vue-toasted'
import Loading from 'vue-loading-overlay';
import Filter from '@/utils/filters'


import Style from '@/assets/main.scss'
import Transition from '@/assets/transitions.css'

import Button from '@/components/general/button.vue'
import StbInput from '@/components/general/stbInput.vue'
import StbCard from '@/components/general/card.vue'
import stbDelete from '@/components/general/delete.vue'

/*
import Button from '@/components/general/button.vue'
import Search from '@/components/general/search.vue'
import CardItem from '@/components/general/card-item.vue'
*/
import Header from '@/components/header.vue'
import Navigation from '@/components/navigation.vue'
import Main from '@/components/main.vue'
import Notifications from '@/components/notifications.vue'
import Profile from '@/components/profile.vue'

import add_vue_property from '@/utils/add_vue_property'

import $api from '@/api'
import $shared from '@/shared'
import $translate from '@/utils/translate'
import $modal from '@/utils/modal'
import gallery from 'vue-gallery'
import 'vue-loading-overlay/dist/vue-loading.css';


Parse.initialize('3iufheaksjf3o2vrnj2o438r2n3o8to23vur832', 'uh3wdnqi3n3thuahdfuHD13norjr38d');
// Parse.serverURL = 'http://localhost:1337/parse'
Parse.serverURL = 'https://stb-backend.funkhaus.io/parse'

Vue.config.productionTip = false;

// plugins
Vue.use(VueStatic);
Vue.use(VueToasted);
Vue.use(Loading, {
	color: '#FF805D',
	canCancel: false,
	loader: 'spinner',
	backgroundColor: '#ffffff',
	zIndex: 99999,
	"is-full-page": true,
});

// components
Vue.component('stb-button', Button);

Vue.component('stb-input', StbInput);
Vue.component('stb-card', StbCard);

Vue.component('stb-header', Header);
Vue.component('stb-navigation', Navigation);
Vue.component('stb-main', Main);
Vue.component('stb-notifications', Notifications);
Vue.component('stb-profile', Profile);
Vue.component('gallery', gallery);
Vue.component('stb-delete', stbDelete);

add_vue_property('$api', $api);
add_vue_property('$shared', $shared);
add_vue_property('$t', $translate);
add_vue_property('$modal', $modal);


Vue.directive("autocomplete", {
                inserted(el, binding) {
                    var self = this;
                    
                    var formatLocation = function(obj) {
                        // console.log(obj);
                        var address_parts = _.filter(obj.address_components, (o) => {
                            return _.intersection(o.types, ["street_number", "route", "locality", "postal_code"]).length > 0;
                        })


                        var values =  _.transform(address_parts, (result, value, key) => {
                            var type = _.intersection(value.types, ["street_number", "route", "locality", "postal_code"])[0];
                            result[type] = value.long_name;
                        }, {})
                        console.log(values);
                        return values;
                    }

                    var createName = function(obj) {
                        var output = "";

                        if (obj["route"] != undefined) {
                            output += obj["route"];
                        }

                        if (obj["street_number"] != undefined) {
                            output += " " + obj["street_number"];
                        }

                        if (obj["route"] != undefined) {
                            output += ",";
                        }


                        if (obj["postal_code"] != undefined) {
                            output += " " + obj["postal_code"];
                        }

                        if (obj["locality"] != undefined) {
                            output += " " + obj["locality"];
                        }

                        return output;
                    }

                    var options = {
                        types: ["address"],
                        componentRestrictions: {
                            country: 'de'
                        }
                    };

                    var ac = new google.maps.places.Autocomplete(el, options);
                    ac.setFields(['address_components', 'geometry', 'name', 'formatted_address', 'adr_address']);
                    ac.addListener('place_changed', function() {
                        if (ac.getPlace().geometry) {
                            var place = ac.getPlace();
                            var position = [
                                place.geometry.location.lat(),
                                place.geometry.location.lng(),
                            ] /* [lat, lng] */

                            var address = formatLocation(place);
                            console.log(address);
                            binding.value.position = position;
                            binding.value.name = createName(address); 
                            binding.value.obj = address;



                            // "street_number", "route", "locality", "postal_code"
                            /*
                            var coords = ac.getPlace().geometry.viewport;
                            binding.value.position = [((coords.f.f + coords.f.b)/2), ((coords.b.f + coords.b.b)/2)];
                            var place = ac.getPlace().name;
                            binding.value.name = place;
                            */
                        }
                        
                    });
                },
            });


/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: {
        App,
    },
    template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js